<template>
  <card id="vanData">
    <!-- Card header -->

    <b-row align-v="center" slot="header">
      <b-col cols="8">
        <h3 slot="header" class="mb-0">
          <i :class="icon"></i>
          {{ title }}
        </h3>
      </b-col>
    </b-row>

    <!-- Card body -->
    <validation-observer ref="formValidator">
      <form class="needs-validation">
        <b-row>
          <b-col md="6">

              <h4>Leistung in KW</h4>
            <base-input
              prepend-icon="fas fa-car"
              placeholder="Leistung in KW"
              v-model="offer.car_kw"
              name="KW"
              rules="required"
            ></base-input>
          </b-col>

          <b-col md="6">

<h4>Aufbauart</h4>

            <base-input
              name="Aufbauart"
              rules="required"
            >


              <el-select
                v-model="offer.body_id"
                filterable
                placeholder="Aufbauart"
              >
                <el-option
                  v-for="option in offer.KRAVAG_VAN_AUFBAUART"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                >
                </el-option>
              </el-select>
            </base-input>




          </b-col>
        </b-row>


        <!-- b-row>

          <b-col md="6">
            <h4>Zulässiges Gesamtgewicht in T</h4>
              <base-input
              prepend-icon="fas fa-car"
              placeholder="Zulässiges Gesamtgewicht in T"
              v-model="offer.vehicle_weight"
              name="Zulässiges Gesamtgewicht in T"
              rules="required"
            ></base-input>
          </b-col>

        </b-row -->





        <b-row>


          <b-col md="6" v-if="this.offer.show_usage">

            <h4>
                Fahrzeugnutzung
            </h4>

            <b-form-radio-group v-model="offer.car_usage" v-if="offer.is_company">
              <div>
                <b-form-radio value="Gewerblich" name="checked" class="mb-3">
                  Gewerblich
                </b-form-radio>
                  <b-form-radio value="Privat und gewerblich" name="unchecked" class="mb-3">
                  Privat und gewerblich
                </b-form-radio>
              </div>
            </b-form-radio-group>





            <b-form-radio-group v-model="offer.car_usage" v-if="!offer.is_company">
              <div>
                <b-form-radio value="Privat" name="checked" class="mb-3">
                  Privat
                </b-form-radio>
                  <b-form-radio value="Privat und gewerblich" name="unchecked" class="mb-3">
                  Privat und gewerblich
                </b-form-radio>
              </div>
            </b-form-radio-group>






          </b-col>

          <b-col md="6">



            <h4>
                Fahrzeugneuwert unter 210.000 € ?
            </h4>

            <b-form-radio-group v-model="offer.new_car_above_max">
              <div>
                <b-form-radio value="false" name="checked" class="mb-3">
                  Ja
                </b-form-radio>
                  <b-form-radio value="true" name="unchecked" class="mb-3">
                  Nein
                </b-form-radio>
              </div>
            </b-form-radio-group>
          </b-col>

        </b-row>

      </form>
    </validation-observer>
  </card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "van",
  props: {
    title: "",
    icon: "",
  },
  components: {
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      loading: false,
      showUsage: false,
      showValue: false,
      below_expensive: 1,
    };
  },
  methods: {
        toggleValue: function(){
            this.showValue = !this.showValue;
        },
        toggleUsage: function(){
            this.showUsage = !this.showUsage;
        },
  },
  computed: {
    ...mapGetters({ currentAccount: "currentAccount" }),
    ...mapState({
      offer: (state) => state.offer,
      car_value: (state) => state.offer.car_value,
      car_usage: (state) => state.offer.car_usage,
      second_vehicle: (state) => state.offer.has_second_vehicle,
      only_driver: (state) => state.offer.holder_only_driver,
      has_holder: (state) => state.offer.has_holder,
      holder_id: (state) => state.offer.holder_id,
      car_first_registration: (state) => state.offer.car_first_registration,
      mileage: (state) => state.offer.mileage,
      insurance_start: (state) => state.offer.insurance_start,
      participation: (state) => state.offer.participation,
      paymentterm: (state) => state.offer.paymentterm,
      radio_usage: (state) => state.offer.radio_usage,
    }),
  },
watch: {
    car_hsn(newValue, oldValue) {
      console.log(`Updating from ${oldValue} to ${newValue}`);
      this.mayFetchCar();
    },
    car_tsn(newValue, oldValue) {
      console.log(`Updating from ${oldValue} to ${newValue}`);
      this.mayFetchCar();
    },

    car_value(newValue, oldValue) {
      console.log(`Updating from ${oldValue} to ${newValue}`);
      this.toggleValue();
    },
    radio_usage(newValue, oldValue) {
      this.offer.selected_usage_only_private = true;

    },

    car_usage(newValue, oldValue) {
      
      console.log(`Updating from ${oldValue} to ${newValue}`);
    
      this.toggleUsage();
      // Do whatever makes sense now
      if (newValue === 'success') {
        this.complex = {
          deep: 'some deep object',
        };
      }
    },
},
  mounted() {
  },
};
</script>
<style>
</style>